import { ApiResponse, ResponseModel } from '../../../../../common/interfaces';
import { useQuery } from 'react-query';
import { useFetch } from '../../../../../hooks/use-fetch/use-fetch';
import { ReactQueryKeys } from '../../../../../common/enums';
import { leasingOfferRequestConfig } from '../../../../../request-config/leasing-offer/leasing-offer.request-config';
import { LeasingOffersFilterDataResponse } from './use-leasing-offers-filter-data.types';
import { RequestStatuses } from '../../../../../constants';

const modifyResponse = ({ data }: ApiResponse<LeasingOffersFilterDataResponse>) => {
  if (data.level === RequestStatuses.Success) {
    return data.data;
  }
  return undefined;
};

const useLeasingOffersFilterData = (vehicleOfferId: string) => {
  const { fetch } = useFetch<ResponseModel<LeasingOffersFilterDataResponse>>({
    loadingKey: 'useLeasingOffersFilterData',
    ...leasingOfferRequestConfig.getGlobalForDriverFilterData(vehicleOfferId)
  });

  const { data: filterData } = useQuery<
    ApiResponse<LeasingOffersFilterDataResponse>,
    unknown,
    LeasingOffersFilterDataResponse | undefined
  >([ReactQueryKeys.GetLeasingOffersFilterData, vehicleOfferId], fetch, {
    enabled: !!vehicleOfferId,
    select: modifyResponse
  });

  return { filterData };
};

export default useLeasingOffersFilterData;
